import React, { useCallback } from 'react';
import { useClient } from '../../../util/useClient';
import { InteriorMaterialClient, IProductGroup, ProductClient } from '../../../services/WebApiClient';
import { GenericEditor } from '../GenericEditor';
import { NavPage } from '../../../services/NavService';
import { usePromise } from '../../EditorCommon/usePromise';
import { LoadSpinner } from '../../LoadSpinner';
import { SingleProductGroupAdmin } from './SingleProductGroupAdmin';
import "./ProductAdminEditor.scss";
import { useState2 } from '../../../util/useState2';

export function ProductAdminEditor(props: {

}) {

    const client = useClient(ProductClient);
    const interiorMaterialClient = useClient(InteriorMaterialClient);
    const selectedId = useState2<{
        productGroupId?: string,
        productSubGroupId?: string,
        productId?: number,
    }>({});

    const getterFunc = useCallback(
        () => client.getProductGroups().then(response => response.productGroups),
        [client]
    );
    const interiorMaterials = usePromise(useCallback(() =>
        interiorMaterialClient.getInteriorMaterials().then(response => response.interiorMaterials),
        [interiorMaterialClient]
    ));


    function editorFunc(productGroup: IProductGroup, onChange: () => void, updateCount: number) {
        if (!interiorMaterials) {
            return <LoadSpinner />;
        }
        return (
            <SingleProductGroupAdmin
                key={`${updateCount} ${productGroup.id}`}
                onChange={onChange}
                productGroup={productGroup}
                interiorMaterials={interiorMaterials}
                selectedProductSubGroupId={{
                    value: selectedId.value.productSubGroupId,
                    set: newId => selectedId.set({
                        productGroupId: selectedId.value.productGroupId,
                        productSubGroupId: newId
                    })
                }}
                selectedProductId={{
                    value: selectedId.value.productId,
                    set: newId => selectedId.set({
                        ...selectedId.value,
                        productId: newId
                    })
                }}
            />
        );
    }

    return (
        <GenericEditor<IProductGroup, string> getterFunc={getterFunc}
            nameFunc={pg => (
                <>
                    <b>{pg.id}</b>
                    <br />
                    <span>{pg.name}</span>
                </>
            )}
            navPage={NavPage.Admin.Product}
            className="product-admin-editor no-right-menu"
            editorFunc={editorFunc}
            selectedId={{
                value: selectedId.value.productGroupId,
                set: newId => selectedId.set({ productGroupId: newId })
            }}
        />
    );
}
